/******/ (function() { // webpackBootstrap
/******/ 	"use strict";

;// ./src/styles/bundles/templates/collection.css
// extracted by mini-css-extract-plugin

;// ./src/js/bundles/templates/collection.js


// document.addEventListener('DOMContentLoaded', () => {
//   new CollectionContainer();
// });
/******/ })()
;